import { BaseErrorPage, NotFoundErrorPage } from "pages/errors";
import HomePage from "pages/Home/HomePage";
import RootWithErrorBoundary from "components/Template/Root";
import { routesConfig } from "config/app-config";
import { createBrowserRouter } from "react-router";
import EpciPageWithErrorBoundary from "pages/Epci/EpciPageWithErrorBoundary";
import CommuneAssocieeDelegueePageWithErrorBoundary from "pages/CommuneAssocieeDeleguee/CommuneAssocieeDelegueePage";
import TerritoirePageWithErrorBoundary from "pages/Territoire/TerritoirePageWithErrorBoundary";
import EluPageWithErrorBoundary from "pages/Elu/EluPageWithErrorBoundary";
import CommunePageWithErrorBoundary from "pages/Commune/CommunePageWithErrorBoundary";
import AdministrationPage from "pages/Administration/AdministrationPage";
import NewPerimetreWithErrorBoundary from "pages/NewPerimetre/NewPerimetreWithErrorBoundary";
import NewTransfertPageWithErrorBoundary from "pages/NewTransfert/NewTransfertPageWithErrorBoundary";
import PerimetrePageWithErrorBoundary from "pages/Perimetre/PerimetrePageWithErrorBoundary";
import PerimetreCommunesAssocieesDeleguesWithErrorBoundary from "pages/PerimetreCommunesAssocieesDelegues/PerimetreCommunesAssocieesDeleguesWithErrorBoundary";
import { FusionPerimetresPageWithErrorBoundary } from "pages/FusionPerimetres/FusionPerimetresPageWithErrorBoundary";
import PerimetreEditTransfertsWithErrorBoundary from "pages/PerimetreEditTransferts/PerimetreEditTransfertsWithErrorBoundary";
import ModifyPerimetreWithErrorBoundary from "pages/ModifyPerimetre/ModifyPerimetreWithErrorBoundary";
import DissoudrePerimetreWithErrorBoundary from "pages/DissoudrePerimetre/DissoudrePerimetreWithErrorBoundary";
import NewPersonneWithErrorBoundary from "pages/NewPersonne/NewPersonneWithErrorBoundary";
import { FusionPersonnesPagesWithErrorBoundary } from "pages/FusionPersonnes/FusionPersonnesPagesWithErrorBoundary";
import AffectationAntenneWithErrorBoundary from "pages/AffectationAntenne/AffectationAntenneWithErrorBoundary";

const authenticatedRouter = createBrowserRouter([
  {
    element: <RootWithErrorBoundary />,
    errorElement: <BaseErrorPage />,
    children: [
      {
        path: routesConfig.home.path,
        element: <HomePage />,
      },
      {
        path: routesConfig.commune.path,
        element: <CommunePageWithErrorBoundary />,
      },
      {
        path: routesConfig.communeAssocieeDeleguee.path,
        element: <CommuneAssocieeDelegueePageWithErrorBoundary />,
      },
      {
        path: routesConfig.epci.path,
        element: <EpciPageWithErrorBoundary />,
      },
      {
        path: routesConfig.territoire.path,
        element: <TerritoirePageWithErrorBoundary />,
      },
      {
        path: routesConfig.perimetre.path,
        element: <PerimetrePageWithErrorBoundary />,
      },
      {
        path: routesConfig.perimetreCommunesAssocieesDeleguees.path,
        element: <PerimetreCommunesAssocieesDeleguesWithErrorBoundary />,
      },
      {
        path: routesConfig.perimetreEditTransferts.path,
        element: <PerimetreEditTransfertsWithErrorBoundary />,
      },
      {
        path: routesConfig.perimetreModify.path,
        element: <ModifyPerimetreWithErrorBoundary />,
      },
      {
        path: routesConfig.elu.path,
        element: <EluPageWithErrorBoundary />,
      },
      {
        path: routesConfig.admin.path,
        element: <AdministrationPage />,
      },
      {
        path: routesConfig.newPerimetre.path,
        element: <NewPerimetreWithErrorBoundary />,
      },
      {
        path: routesConfig.fusionPerimetres.path,
        element: <FusionPerimetresPageWithErrorBoundary />,
      },
      {
        path: routesConfig.dissoudrePerimetre.path,
        element: <DissoudrePerimetreWithErrorBoundary />,
      },
      {
        path: routesConfig.newTransferts.path,
        element: <NewTransfertPageWithErrorBoundary />,
      },
      {
        path: routesConfig.newPersonne.path,
        element: <NewPersonneWithErrorBoundary />,
      },
      {
        path: routesConfig.fusionPersonnes.path,
        element: <FusionPersonnesPagesWithErrorBoundary />,
      },
      {
        path: routesConfig.antennesAffectationCommunes.path,
        element: <AffectationAntenneWithErrorBoundary />,
      },
      {
        path: routesConfig.any.path,
        element: <NotFoundErrorPage />,
      },
    ],
  },
]);

export default authenticatedRouter;
